import { apiFetch } from "./client";

export interface AgentPresence {
  pendingApprovals: number;
  unreadDirect: number;
  activeRuns: number;
  activeTasks: number;
  lastFailureAt: string | null;
  lastFailureKind: "workflow" | "task" | null;
  lastActivityAt: string | null;
}

export interface AgentPresenceResponse {
  agents: Record<string, AgentPresence>;
  generatedAt: string;
}

export const agentPresenceApi = {
  byCompany: (companyId: string) =>
    apiFetch<AgentPresenceResponse>(`/companies/${companyId}/agents/presence`),
};
